import React from "react";

const createFmpScript = (createElement) => {
  const fmpScriptConfig = {
    type: 'text/javascript',
    dangerouslySetInnerHTML: {
      __html: '(function() { performance.mark("first-meaningful-paint"); })();'
    }
  };
  return createElement('script', fmpScriptConfig);
};

const reactDecorator = {
  createElement: function (createElement, ...args) {
    const elementFactory = () => createElement(...args);
    const [type, config] = [...args];

    // If it becomes necessary to switch on more sub-types, we can refactor this into the Visitor pattern
    try {
      switch (typeof type) {
        case "function":
          switch (type.name) {
            case "HTML":
              const configTop = {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html:
                    '(function() { performance.mark("parseBodyStarted"); })();',
                },
              };
              const configBottom = {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html:
                    '(function() { performance.mark("parseBodyCompleted"); })();',
                },
              };
              const preScript = createElement("script", configTop);
              const postScript = createElement("script", configBottom);

              if (Array.isArray(config.preBodyComponents)) {
                config.preBodyComponents.push(preScript);
              }
              if (Array.isArray(config.postBodyComponents)) {
                config.postBodyComponents.push(postScript);
              }

              return elementFactory();
          }
          break;
        case "string":
          switch (type) {
            case "h2": 
              if (config && config.pltmark && config.pltmark === "first-meaningful-paint")
              {
                const fmpScript = createFmpScript(createElement);
                return createElement(
                  React.Fragment,
                  {},
                  elementFactory(),
                  fmpScript
                );
              }
              break;
            case "h1":
              const fmpScript = createFmpScript(createElement);
              return createElement(
                React.Fragment,
                {},
                elementFactory(),
                fmpScript
              );
            case "div":
              if (
                config &&
                config.className &&
                config.className.includes("standard-hero-image")
              ) {
                const fmpScript = createFmpScript(createElement);
                return createElement(
                  React.Fragment,
                  {},
                  elementFactory(),
                  fmpScript
                );
              }
              else if (config && config.pltmark && config.pltmark === "first-meaningful-paint"){
                const fmpScript = createFmpScript(createElement);
                return createElement(
                  React.Fragment,
                  {},
                  elementFactory(),
                  fmpScript
                );
              }
              break;
            case "aside":
                if (config && config.pltmark && config.pltmark === "first-meaningful-paint"){
                  const fmpScript = createFmpScript(createElement);
                  return createElement(
                    React.Fragment,
                    {},
                    elementFactory(),
                    fmpScript
                  );
                }
              break;
            default:
              break;
          }
        default:
          break;
      }
    } catch (ex) {
      console.log("[ReactWrapper] unable to wrap element", ex);
    }

    return elementFactory();
  },
};

export default reactDecorator;
